(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["block-floating-image"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (typeof gsap === 'undefined') return;
    if (typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger); 
    }

    document.querySelectorAll('[data-fi-sprite-animation]').forEach(function (el) {
      var type = el.dataset.fiSpriteAnimation;
      var frames = parseInt(el.dataset.fiSpriteFrames, 10);
      var speedTenths = parseInt(el.dataset.fiSpriteSpeed, 10);
      var duration = speedTenths / 10;
      var steps = frames - 1;
      var scrollStart = el.dataset.fiScrollStart || 'top bottom';
      var scrollEnd = el.dataset.fiScrollEnd || 'bottom top';
      var parent = el.closest('.section-wrapper') || el.parentElement;
      var triggerElement = parent && parent.offsetHeight > 0 ? parent : el;

      if (type === 'sprite-loop') {
        gsap.fromTo(el,
          { backgroundPosition: '0% 0%' },
          {
            backgroundPosition: '0% 100%',
            ease: 'steps(' + steps + ')',
            duration: duration,
            repeat: -1
          }
        );
      } else if (type === 'sprite-on-scroll') {
        if (typeof ScrollTrigger === 'undefined') {
          return;
        }

        gsap.fromTo(el,
          { backgroundPosition: '0% 0%' },
          {
            backgroundPosition: '0% 100%',
            ease: 'steps(' + steps + ')',
            scrollTrigger: {
              trigger: triggerElement,
              start: scrollStart,
              end: scrollEnd,
              scrub: true
            }
          }
        );
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
